"use strict";
import { __module as u } from "./index.es464.js";
import { __require as c } from "./index.es465.js";
var a;
function d() {
  return a ? u.exports : (a = 1, (function(o, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "detectDomainLocale", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const i = function() {
      for (var n = arguments.length, r = new Array(n), t = 0; t < n; t++)
        r[t] = arguments[t];
      if (process.env.__NEXT_I18N_SUPPORT)
        return c().detectDomainLocale(...r);
    };
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), o.exports = e.default);
  })(u, u.exports), u.exports);
}
export {
  d as __require
};
//# sourceMappingURL=index.es396.js.map
